@if (loginHidden !== true) {
  <div
    style="position: absolute; top: 15px; right: 50px; z-index: 100; max-height: 100vh">
    <div
      fxLayout="row"
      fxLayoutAlign="center center">
      @if (languages?.length > 1) {
        <div
          class="mr-4">
          <div class="select is-primary is-small">
            <select
              class="dropdown-item-small"
              [(ngModel)]="selectedCultureCode"
              (ngModelChange)="languageSelected()">
              @for (lang of languages; track lang) {
                <option
                  [ngValue]="lang">
                  {{ getLanguageDisplay(lang) }}
                </option>
              }
            </select>
          </div>
        </div>
      }
      <topo-theme-switcher></topo-theme-switcher>
    </div>
  </div>
}

@if (loginHidden !== true) {
  <div
    class="login-content"
    fxLayout="column"
    fxLayoutAlign="center center">
    <div>
      <div
        class="c24-logo"
        fxLayout="row"
        fxLayoutAlign="center center">
        <div>
          <img
            class="light-logo"
            src="/assets/images/crisis24-logo.svg" />
          <img
            class="dark-logo"
            src="/assets/images/crisis24-logo-reverse.svg" />
        </div>
      </div>
      <div class="box is-elevation-3 login-box">
        <form [formGroup]="form">
          <div
            fxLayout="column"
            fxLayoutAlign="space-between center"
            style="width: 100%">
            <div
              fxLayout="row"
              fxLayoutAlign="space-between center"
              style="width: 100%">
              <div>
                <img
                  class="light-topo"
                  src="/assets/images/topoone-by-crisis24.svg" />
                <img
                  class="dark-topo"
                  src="/assets/images/topoone-by-crisis24-white.svg" />
              </div>
              <div class="login-label">{{ 'LOGIN.LOGIN' | translate }}</div>
            </div>
            @if (!(showPassword$ | async)) {
              <div
                fxLayout="column"
                fxLayoutAlign="space-around center">
                <input
                  (keyup.enter)="loginStepEmail()"
                  class="input is-fullwidth mt-5 mb-2"
                  type="text"
                  placeholder="{{ 'LOGIN.EMAIL-ADDRESS' | translate }}"
                  formControlName="username"
                  style="width: 312px" />
                <button
                  [disabled]="isWorking$ | async"
                  class="button is-primary is-medium my-5"
                  style="width: 100%"
                  (click)="loginStepEmail()">
                  {{ ((isWorking$ | async) ? 'LOGIN.WORKING' : 'LOGIN.NEXT') | translate }}
                </button>
                <topo-app-disclaimer style="width: 312px" />
              </div>
            }
            @if (showPassword$ | async) {
              <div
                fxLayout="column"
                fxLayoutAlign="space-around center">
                <div
                  fxLayout="row"
                  fxLayoutAlign="start"
                  fxFill
                  class="mt-5">
                  <span class="text is-bolder is-large pl-2">{{ username$ | async }}</span>
                </div>
                <input
                  (keyup.enter)="loginStepPassword()"
                  class="input mt-3"
                  type="password"
                  placeholder="{{ 'LOGIN.PASSWORD' | translate }}"
                  formControlName="password"
                  style="width: 312px" />
                <button
                  [disabled]="isWorking$ | async"
                  class="button is-fullwidth is-primary is-small mt-5"
                  style="width: 100%"
                  (click)="loginStepPassword()">
                  {{ ((isWorking$ | async) ? 'LOGIN.WORKING' : 'LOGIN.LOGIN') | translate }}
                </button>
                @if (!(isWorking$ | async)) {
                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-between"
                    class="mt-4"
                    style="width: 100%">
                    <button
                      [disabled]="isWorking$ | async"
                      class="button is-ghost is-small"
                      (click)="forgotPassword()">
                      {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
                    </button>
                    <button
                      [disabled]="isWorking$ | async"
                      class="button is-ghost is-small"
                      (click)="backToEmail()">
                      {{ 'LOGIN.CHANGE_ACCOUNT' | translate }}
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        </form>
      </div>
    </div>
  </div>
}

<div class="glyph"><!-- img src="/assets/images/topoone-login-globe.svg" / --></div>

@if (isWorking) {
  <topo-spinner></topo-spinner>
}

<topo-confirm
  class="sendResetConfirm"
  [isActive]="showConfirm"
  (respond)="confirmPasswordLinkResponse($event)"
  title="{{ 'LOGIN.CONFIRM_SEND_RESET_LINK' | translate }}"
  message="{{ 'LOGIN.CONFIRM_RESET_MESSAGE' | translate }}"
  noText="{{ 'MAP.CONFIRM-NO' | translate }}"
  yesText="{{ 'MAP.CONFIRM-YES' | translate }}"
icon="icon-alert_solid"></topo-confirm>

<topo-policy-acceptance></topo-policy-acceptance>
<topo-business-units-warning></topo-business-units-warning>
